import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpRequestService } from './http-request.service';


@Injectable({
  providedIn: 'root'
})
export class CountryAndCityService {

  constructor(private http: HttpClient, private httpRes: HttpRequestService) { }

  // Note : I am getting all countries from database , then get the country details from api, to get countryPhoneCode cause it does not exist in db.

  //https://countrystatecity.in/docs/api/country/     api website url
  GetAllCountriesFromApi()
  {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "X-CSCAPI-KEY": "T0lFYUpMNGZGb1VaSjlNaWR2eEpaenAyaW9URXZXOUwwcVA3QWJBSA=="
    });

    return this.http.get(`https://api.countrystatecity.in/v1/countries`,{headers: headers});
  }
  GetAllCountriesFromDb()
  {
    return this.httpRes.GetRequest(`Country/GetCountries`);
  }


  GetAllCitiesFromApi(CountryCode)
  {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "X-CSCAPI-KEY": "T0lFYUpMNGZGb1VaSjlNaWR2eEpaenAyaW9URXZXOUwwcVA3QWJBSA=="
    });

    return this.http.get(`https://api.countrystatecity.in/v1/countries/${CountryCode}/cities`,{headers: headers});
  }

  GetCountryCitiesFromDb(countryId)
  {
    return this.httpRes.GetRequest(`City/GetCountryCities/${countryId}`);
  }

  GetCountryDetailsFromApi(CountryCode)
  {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "X-CSCAPI-KEY": "T0lFYUpMNGZGb1VaSjlNaWR2eEpaenAyaW9URXZXOUwwcVA3QWJBSA=="
    });

    return this.http.get(`https://api.countrystatecity.in/v1/countries/${CountryCode}`,{headers: headers});
  }
}
